



























import { Component, Vue, Watch } from "vue-property-decorator";
import { Getter, Action } from "vuex-class";
// import PHeaders from "./layoutHeader.vue";
import PMenu from "./menu.vue";
import { menuList } from "./data/menuList";
import PHeader from "./headerLayout.vue";
import { getFeedbackUrl2 } from "@/utils/getHost";
Component.registerHooks([
  "beforeRouteEnter",
  "beforeRouteLeave",
  "beforeRouteUpdate",
]);

@Component({
  components: { PMenu, PHeader },
})
export default class Layout extends Vue {
  // vuex
  @Getter("user/userInfo") public userInfo: any;
  @Getter("app/actionMenuQuestionnaire") public actionMenuQuestionnaire: any;
  @Action("user/getUserInfo") public getUserInfo: any;
  // data
  private marLeft = 1200;
  private inResize = false;
  private isCollapse = false;
  private feedbackUrl = getFeedbackUrl2();
  private questionId: any = this.$route.query.questionId;
  // watch
  @Watch("$route") private watchRoute(val: any, oldVal: any) {
    console.log(val);
    if (val.meta.parentTab !== oldVal.meta.parentTab) {
      this.inResize = true;
      this.$nextTick(() => {
        this.inResize = false;
      });
    }
    // console.log(val.meta.parentTab, "val.meta.parentTab");
    // console.log(this.$route.path, "oldVal.meta.parentTab");
  }
  // computed
  private get siderStyle() {
    return {
      marginLeft: `-${this.marLeft / 2}px`,
    };
  }
  private get userMenu(): any[] {
    let list: any = [];

    list = menuList;
    return list;
  }
  private beforeRouteEnter(to: any, from: any, next: any) {
    // 刷新时起作用
    next((vm: any) => {
      // if (to.path.includes("/questionnaire/edit")) {
      //   vm.isCollapse = true;
      // } else {
      //   vm.isCollapse = false;
      // }
    });
  }
  // 路由更新
  private beforeRouteUpdate(to: any, from: any, next: any) {
    // 跳转时起作用
    // if (to.path.includes("/questionnaire/edit")) {
    //   this.isCollapse = true;
    // } else {
    //   this.isCollapse = false;
    // }
    next();
  }
  // 当离开当前路由时
  private beforeRouteLeave(to: any, from: any, next: any) {
    next();
  }
  private toOption() {
    // this.$router.push("/help.html?articleType=4");
    // const { href } = this.$router.resolve({
    //   path: "/help.html",
    //   query: {
    //     articleType: "4",
    //   },
    // });
    // window.open(href, "_blank");
    window.open(this.feedbackUrl, "_blank");
  }
  /**
   * @description: 导航菜单跳转
   * @param {*} routePath
   */
  private menuSelect(routePath: any): void {
    // console.log(routePath, "路由");
    // console.log(this.$route.query.questionId);
    // console.log(this.$tool.decrypt(this.$route.query.questionId));
    this.$router.push({
      path: routePath,
      query: {
        questionId: this.$route.query.questionId,
      },
    });
  }

  // created
  private async created() {
    // console.log(this.$route);
    if (!this.userInfo.username) {
      try {
        await this.getUserInfo();
      } catch (error) {
        console.log(error);
      }
    }
  }
  // mounted
  // private mounted() {}
  // private getCollapse() {
  //   // console.log("isCollapse", this.isCollapse);
  //   if (!this.isCollapse) {
  //     this.isCollapse = true;
  //   } else {
  //     this.isCollapse = false;
  //   }
  // }
}
